// extracted by mini-css-extract-plugin
export default {"infoCell":"h33n93OCTfi9EAY3bSM5","noInfo":"QpDgzCvnr06B2Ochso9A"};